import { Trade} from '@/types/trade';

export class TradesQueue {
  private trades: Trade[] = [];
  constructor(private period: number = 0) {}
  public getTrades(seconds = 0) {
    if (seconds === 0) {
      return this.trades;
    } else {
      return this.trades.filter((v) => {
        return v.timestamp > Date.now() - seconds;
      });
    }
  }
  public setPeriod(period: number) {
    this.period = period;
  }
  public enqueue(trade: Trade) {
    this.trades.push(trade);
    this.trades = this.trades.filter((v) => {
      return v.timestamp > Date.now() - this.period;
    });
  }
  public dequeue() {
    const lastTrades = this.trades;
    this.trades = [];
    return lastTrades;
  }
  public clear() {
    this.trades = [];
  }
}
